const formatPhone = function(input) {
  if (input == null || input == undefined || input === '') { return ''; }
  var sinput = String(input).replace(/[^\d]/g,'').replace(/^1/,'');
  if (sinput.length == 10) {
    return "(" + sinput.substring(0,3) + ") " +
      sinput.substring(3,6) + "-" + sinput.substring(6,10);
  }
  return sinput;
}

var filter = function() {
  return function(input) {
    return formatPhone(input);
  };
};


filter.$inject = [];

tiz.filter('phone', filter);

export default formatPhone;